module.exports = __webpack_public_path__ + "img/myyaak.68173706.png";